import Text from 'common-components/Text'
import styled, { css } from 'styled-components'

export const TabbarWrapper = styled.div`
  width: 100%;
  margin-bottom: 16px;
`

export const MusicTabContentWrapper = styled.div<{
  $isRemoveTopPadding: boolean
}>`
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  ${props =>
    props.$isRemoveTopPadding &&
    css`
      padding-top: 0;
    `}
`

export const MyMusicTitleForVisualizer = styled(Text)`
  margin-inline-end: auto;
  padding-inline-start: 16px;
  padding-bottom: 2px;
  padding-top: 4px;
`
